var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { KeyAttributeValue } from '@hawkins/helpers';
import { IconClose } from '@hawkins/icons/lib/iconClose';
import { IconSearch } from '@hawkins/icons/lib/iconSearch';
import { Button } from '../../../button';
import { useCombineRefs } from '../../../hooks';
import { Input } from '../../../input';
import { DropdownTestIds } from '../../dropdown.constants';
import { useDebouncedSearch } from '../hooks/useDebouncedSearch';
var displayName = 'DropdownInput';
/**
 * Default component for the dropdown trigger if the component is a autoComplete
 * @param param
 * @returns
 */
export function DropdownInput(_a) {
    var ariaDescribedby = _a.ariaDescribedby, ariaOwns = _a.ariaOwns, _b = _a.borderless, borderless = _b === void 0 ? false : _b, classes = _a.classes, compact = _a.compact, creatable = _a.creatable, debounceTime = _a.debounceTime, description = _a.description, disabled = _a.disabled, focused = _a.focused, _c = _a.getOptionLabel, getOptionLabel = _c === void 0 ? function (option) { return option.label; } : _c, handleClearInput = _a.handleClearInput, id = _a.id, _d = _a.inputProps, _e = _d === void 0 ? {} : _d, inputPropsRef = _e.ref, inputProps = __rest(_e, ["ref"]), label = _a.label, name = _a.name, _f = _a.navigational, navigational = _f === void 0 ? false : _f, onBlur = _a.onBlur, onClick = _a.onClick, onFocus = _a.onFocus, onInputChange = _a.onInputChange, onKeyDown = _a.onKeyDown, requirementType = _a.requirementType, placeholder = _a.placeholder, selected = _a.selected, startAdornment = _a.startAdornment, triggerRef = _a.triggerRef, inputContainerProps = _a.inputContainerProps, _g = _a.validationMessage, validationMessage = _g === void 0 ? undefined : _g, _h = _a.validationStatus, validationStatus = _h === void 0 ? undefined : _h;
    var combinedInputRef = useCombineRefs([triggerRef, inputPropsRef]);
    var initialValue = (selected === null || selected === void 0 ? void 0 : selected[0]) ? getOptionLabel(selected[0]) : '';
    var _j = useDebouncedSearch(initialValue, debounceTime, onInputChange), searchQuery = _j.searchQuery, handleQueryChange = _j.handleQueryChange, setSearchQuery = _j.setSearchQuery;
    return (_jsx(Input, __assign({ active: focused, "data-testid": DropdownTestIds.INPUT, ref: combinedInputRef, "aria-activedescendant": "", "aria-autocomplete": "both", "aria-describedby": ariaDescribedby, "aria-owns": ariaOwns, autoComplete: "off", compact: compact, borderless: borderless || navigational, description: description, endAdornment: initialValue ? (_jsx(Button, { variant: "icon", "aria-label": "clear", compact: true, icon: IconClose, className: classes.clearButton, onClick: function (e) {
                setSearchQuery('');
                handleClearInput && handleClearInput(e);
            }, onBlur: function (e) {
                setTimeout(function () {
                    // wait to apply onblur so it doesn't clash with other actions
                    // such as the click event to select elements in the list
                    // here we keep the list open if creatable and the list is already open
                    if (focused) {
                        var keepListOpen = creatable && focused && selected && (selected === null || selected === void 0 ? void 0 : selected.length) > 0;
                        onBlur && onBlur(e, keepListOpen);
                    }
                }, 200);
            }, "data-hawkins-style": "Hawkins-Dropdown-clearButton", "data-testid": DropdownTestIds.CLEAR_BUTTON })) : (_jsx(IconSearch, {})), fullWidth: true, id: id, label: label, name: name, onChange: handleQueryChange, onKeyDown: function (e) {
            var key = e.key;
            // first clear on escape
            if (key === KeyAttributeValue.ESCAPE)
                setSearchQuery('');
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }, placeholder: placeholder, requirementType: requirementType, validationMessage: validationMessage, validationStatus: validationStatus, value: searchQuery, startAdornment: startAdornment, readOnly: disabled === true, onClick: function (e) { return onClick && onClick(e, true); }, styleReadOnlyAsDisabled: disabled === true }, inputProps, { onFocus: onFocus, onBlur: function (e) {
            setTimeout(function () {
                // wait to apply onblur so it doesn't clash with other actions
                // such as the click event to select elements in the list
                // here we keep the list open if creatable and the list is already open
                if (focused) {
                    onBlur && onBlur(e, true);
                }
            }, 200);
        }, containerProps: inputContainerProps })));
}
DropdownInput.displayName = displayName;
